import { render, staticRenderFns } from "./ProjectInstallation.vue?vue&type=template&id=48b6bbda&scoped=true"
import script from "./ProjectInstallation.vue?vue&type=script&lang=js"
export * from "./ProjectInstallation.vue?vue&type=script&lang=js"
import style0 from "./ProjectInstallation.vue?vue&type=style&index=0&id=48b6bbda&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b6bbda",
  null
  
)

export default component.exports